import * as Yup from 'yup'
import oneOfMapper from 'utils/validators/oneOfMapper'
import { AVAILABLE_CURRENCIES, WALLET_PREFIX } from 'constants/app-config'
import i18n from 'i18next'

const schema = () =>
  Yup.object().shape({
    type: Yup.string()
      .oneOf(['epayments', 'webmoney', 'capitalist'])
      .required('common::validation_messages.required'),
    contacts: Yup.object().when('type', {
      is: 'capitalist',
      then: (schema) =>
        schema.shape({
          country: Yup.string(),
          city: Yup.number(),
          address: Yup.string(),
          zip_code: Yup.string(),
        }),
      otherwise: (schema) => schema.strip(),
    }),
    name: Yup.string().required('common::validation_messages.required'),
    currency: Yup.string()
      .required('common::validation_messages.required')
      .when('type', ([type], schema) =>
        type == 'capitalist'
          ? schema.oneOf(AVAILABLE_CURRENCIES[type], ({ values }) =>
              oneOfMapper(
                values,
                'common::validation_messages.oneOf',
                `common::currencies.`,
              ),
            )
          : schema.oneOf(AVAILABLE_CURRENCIES, ({ values }) =>
              oneOfMapper(
                values,
                'common::validation_messages.oneOf',
                `common::currencies.`,
              ),
            ),
      ),

    wallet: Yup.string().when('type', ([type], schema) =>
      type === 'capitalist'
        ? schema.test('capitalistWalletId', function (value) {
            const { path, createError } = this

            let isValid = false
            const reg = new RegExp(`${WALLET_PREFIX[type]}\\d{7,8}`)

            isValid = value.match(reg)

            return (
              isValid ||
              createError({
                path,
                message: i18n.t(
                  'referral::payout_profiles_new.fields.wallet.errors.incorrect_format_capitalist',
                  { prefix: WALLET_PREFIX[type] },
                ),
              })
            )
          })
        : schema.required('common::validation_messages.required'),
    ),
  })

export default schema
